import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { PageHeader, IframeView } from '../../components';
import { META_TITLE } from '../../utils/constants';
import { buildIframeUrl } from '../../utils/iframe';
import * as S from './Support.styles';

export default function Support() {
	const currentLocation = useSelector((state) => state.location.value);

	useEffect(() => {
		// Set document title
		document.title = `Support | ${META_TITLE}`;
	}, []);

	return (
		<S.Wrapper>
			<PageHeader>Support</PageHeader>
			<IframeView src={buildIframeUrl('cpSupport', { locationID: currentLocation?.LocationID })} title="Support" />
		</S.Wrapper>
	);
}
